import { Col, Form, Input, Modal, Row, Button } from "antd";
import React from "react";
import { PostListDepartment } from "../../api/lsDepartment";
import { useState } from "react";
import { ToastError, ToastSuccess } from "../../components/ToastSwal";

const ModalAddDepartment = ({
  isModalOpenAddDepartment,
  handleOkAddDepartment,
  setIsModalOpenAddDepartment,
  fetchListDataDepartment,
}) => {
  const [form] = Form.useForm();
  const [loadings, setLoadings] = useState(false);

  const handleCancelAddDepartment = () => {
    setIsModalOpenAddDepartment(false);
    form.resetFields();
  };

  const onFinish = (values) => {
    var FormData = require("form-data");
    var data = new FormData();
    setLoadings(!loadings);
    data.append("message", "create");
    data.append("codedepart", values.codedepart);
    data.append("namedepart", values.namedepart);
    // currentDuAn
    PostListDepartment(data)
      .then((res) => {
        ToastSuccess.fire({
          icon: "success",
          title: "Thêm mới Department thành công",
        });
        setLoadings(false);
        fetchListDataDepartment();
        handleCancelAddDepartment();
      })
      .catch((error) => {
        ToastError.fire({
          icon: "error",
          title: error.data.message,
        });
      });
  };

  return (
    <Modal
      title="ADD DEPARTMENT"
      open={isModalOpenAddDepartment}
      onOk={handleOkAddDepartment}
      onCancel={handleCancelAddDepartment}
      footer={false}
      width={800}
      forceRender={true}
      className="headerTitleModal"
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        // validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
      >
        <Row>
          <Col span={11}>
            <Form.Item
              label="Department Name"
              name="namedepart"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Department Name!",
                },
              ]}
            >
              <Input size="large" placeholder="Department Name" />
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col span={11}>
            <Form.Item
              label="Department Code"
              name="codedepart"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Department Code!",
                },
              ]}
            >
              <Input size="large" placeholder="Department Code" />
            </Form.Item>
          </Col>
          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              className="btnSaveModel"
              type="success"
              htmlType="submit"
              variant="contained"
              loading={loadings}
            >
              Save
            </Button>
            <Button
              className="btnCancelModel"
              variant="outlined"
              onClick={handleCancelAddDepartment}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalAddDepartment;
